import { DirectSubChannel, SensorPortCommunicationMode } from "../../../portConfigs.js";
import { SensorClusterConfig, SensorElementOutput } from "../types.js";

// ─── Soil tension sensors (ADC, volts -> kPa) ────────────────────────────────
//
// Both sensors here wire to a single ADC_5V sub-channel and share the
// soilTension element's linearWithMinAndMax conversion. Neither has any
// cluster-level configurable parameters — the slope/offset come from the
// legacy per-sensor-type calibration and are baked into the element output.

const watermarkElements: SensorElementOutput<"soilTension">[] = [
    {
        sensorElementConfigKey: "soilTension",
        // Legacy `watermark` (SensorConfiguration.ts): value = volt * 85.357
        parameters: { slopeKpaPerVolt: 85.357, offsetKpa: 0 },
        legalConvertedRange: [0, null],
        subChannel: DirectSubChannel.ADC_5V,
    },
];

const irrometerElements: SensorElementOutput<"soilTension">[] = [
    {
        sensorElementConfigKey: "soilTension",
        // Legacy `irrometer` (SensorConfiguration.ts): value = max(0, 23.5 * volts - 11.75)
        parameters: { slopeKpaPerVolt: 23.5, offsetKpa: -11.75 },
        legalConvertedRange: [0, null],
        subChannel: DirectSubChannel.ADC_5V,
    },
];

export const soilTensionClusterConfigs: Record<string, SensorClusterConfig<Record<string, never>>> = {
    Watermark_200SS: {
        communicationMode: SensorPortCommunicationMode.DIRECT,
        requiredSubChannels: [DirectSubChannel.ADC_5V],
        optionalSubChannels: [],
        isPermanentlyAttached: false,
        parameterConfigs: {},
        manufacturerName: "Irrometer",
        modelName: "200SS",
        friendlyName: "Watermark",
        friendlyShortName: "Watermark",
        generateSensorElements: () => watermarkElements,
        migrationProperties: {
            legacySensorType: "watermark",
            legacyParametersToClusterParameters: () => ({}),
            clusterParametersToLegacyParameters: () => ({}),
        },
    },

    Irrometer_Tensiometer: {
        communicationMode: SensorPortCommunicationMode.DIRECT,
        requiredSubChannels: [DirectSubChannel.ADC_5V],
        optionalSubChannels: [],
        isPermanentlyAttached: false,
        parameterConfigs: {},
        manufacturerName: "Irrometer",
        modelName: "Tensiometer",
        friendlyName: "Tensiometer",
        friendlyShortName: "Tensiometer",
        generateSensorElements: () => irrometerElements,
        migrationProperties: {
            legacySensorType: "irrometer",
            legacyParametersToClusterParameters: () => ({}),
            clusterParametersToLegacyParameters: () => ({}),
        },
    },
};
